import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/** Path tipo WordPress Pretty Link: /link/<uuid> — non è una route dell'app. */
const WORDPRESS_PUBLIC_ORIGIN = 'https://divinea.com';

@Component({
  standalone: true,
  template: `<p style="padding:1rem;text-align:center;font-family:system-ui,sans-serif">Reindirizzamento…</p>`,
})
export class ExternalLinkRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!isPlatformBrowser(this.platformId) || !id) {
      return;
    }
    window.location.replace(`${WORDPRESS_PUBLIC_ORIGIN}/link/${encodeURIComponent(id)}`);
  }
}
